import React, { JSX } from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';
// REMOVE this import:
// import SplashScreen from './SplashScreen';

export default function PrivateRoute({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  
  // 1) While Firebase is still initializing, don’t redirect yet:
  if (loading) {
    console.log('[PrivateRoute] auth loading… holding off');
    return null; // or a minimal spinner
  }

  if (!user) {
    console.log('[PrivateRoute] no user → redirect to /auth');
    return <Navigate to="/auth" replace />;
  }

  console.log('[PrivateRoute] have user → rendering protected UI');
  return children;
}